import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, startWith } from 'rxjs/operators';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { BlogTag } from '../../../models/blog-post.model';
import { BlogListingModel } from '../../../models/blog-listing.model';

@Component({
  selector: 'mj-blog-tag',
  templateUrl: './blog-tag.component.html',
  styleUrls: ['./blog-tag.component.scss'],
})
export class BlogTagComponent implements OnInit {
  @Input() tags: Array<BlogTag>;
  @Input() blogListing: BlogListingModel;
  @Output() didSelectTag = new EventEmitter<BlogTag>();
  @Output() didAddTag = new EventEmitter<BlogTag>();
  @Output() didRemoveTag = new EventEmitter<BlogTag>();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  tagCtrl = new FormControl();

  filteredTags: Observable<Array<BlogTag>>;

  @ViewChild('fruitInput', { static: false }) fruitInput: ElementRef<
    HTMLInputElement
  >;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  constructor() {
    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => (tag ? this._filter(tag) : this.tags.slice()))
    );
  }

  ngOnInit() {}

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        this.didAddTag.emit({
          name: value.trim(),
        });
      }

      if (input) {
        input.value = '';
      }

      this.tagCtrl.setValue(null);
    }
  }

  remove(tag: BlogTag): void {
    this.didRemoveTag.emit(tag);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const query_tag = this.tags.filter(tag => {
      return tag.name.toLowerCase() === event.option.value.toLowerCase();
    });
    this.didSelectTag.emit(query_tag[0]);
    this.fruitInput.nativeElement.value = '';
    this.tagCtrl.setValue(null);
  }

  private _filter(value: string): Array<BlogTag> {
    const filterValue = value.toLowerCase();
    return this.tags.filter(
      tag => tag.name.toLowerCase().indexOf(filterValue) === 0
    );
  }
}
